import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=622b209e&scoped=true&"
import script from "./UserUpdate.vue?vue&type=script&lang=js&"
export * from "./UserUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UserUpdate.vue?vue&type=style&index=0&id=622b209e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b209e",
  null
  
)

export default component.exports